import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'ds-report-header',
  templateUrl: './report-header.component.html',
  styleUrls: ['./report-header.component.scss'],
})
export class ReportHeaderComponent implements OnInit {

  @Input() title: string;
  @Input() subtitle: string;
  @Input() dateFrom: Date;
  @Input() dateTo: Date;
  @Input() showWarning: boolean = false;
  @Input() warningContent: string;
  
  _dateFrom:Date;
  _dateTo:Date;
  
  constructor() { }

  ngOnInit() {
    this._dateFrom = new Date(this.dateFrom);
    this._dateTo = new Date(this.dateTo);
  }

}
